module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app-layout', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "bloc bgc-tangerine-yellow d-bloc",
    attrs: {
      "id": "bloc-303"
    }
  }, [_c('div', {
    staticClass: "container bloc-sm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h2', {
    staticClass: "mg-md text-center tc-white"
  }, [_c('strong', [_vm._v("Uusi tarjouspyyntö")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  })])])])])]), _vm._v(" "), _c('v-bloc', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('v-quote-preview-body')], 1)]), _vm._v(" "), _c('v-bloc', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', [_c('div', {
    staticClass: "panel alert-padding"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('h3', {
    staticClass: "text-center mg-sm"
  }, [_c('strong', [_vm._v("Vastaa yritykselle")])]), _vm._v(" "), _c('div', {
    staticClass: "divider-h"
  }, [_c('span', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('router-link', {
    staticClass: "btn btn-lg btn-lime-green",
    attrs: {
      "to": {
        name: 'make-offer.index',
        params: {
          quoteId: _vm.$store.state.route.params.quoteId
        }
      }
    }
  }, [_vm._v("Tee tarjous")])], 1)])])])])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5c05979e"}!./src/app/pages/quote/quote.html
// module id = 483
// module chunks = 1